import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const Excerpt = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  marginBlockStart: "100",
  marginBlockEnd: "800",
  children: children
});
export default Excerpt;